import { render } from "./GuiQuestionParentSelect.vue?vue&type=template&id=49ae0e32"
import script from "./GuiQuestionParentSelect.vue?vue&type=script&lang=js"
export * from "./GuiQuestionParentSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__